<template>
    <div>
        <div class="row">
            <div class="col-sm-1">
                <div class="form-group">
                    <label class="label-control blue">{{$t('year')}}</label>
                    <div>
                        <select class="form-control form-control-sm" v-model="query.Year" @change="toList">
                            <option v-for="ret in $years()" :value="ret" :key="ret">{{ret}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-sm-1">
                <div class="form-group">
                    <label class="label-control blue">{{$t('month')}}</label>
                    <div>
                        <select class="form-control form-control-sm" v-model="query.Month" @change="toList">
                            <option v-for="n in 12" :value="n" :key="n">{{$t('month_' + n)}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="form-group">
                    <label class="label-control blue">{{$t('customer')}}</label>
                    <div>
                        <CustomerDropdown :is-all="true" :place="$t('all')" @select="customerChange"></CustomerDropdown>
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="form-group">
                    <label class="label-control blue">{{$t('sale_reputation')}}</label>
                    <div>
                        <select class="form-control form-control-sm" v-model="query.EmployeeId" @change="toList">
                            <option value="">{{$t('all')}}</option>
                            <option v-for="ret in employees" :value="ret.Id" :key="ret.Id">{{ret.Num}} : {{ret.KhmerName}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <table class="table table-bordered table-sm table-striped no-bor">
                    <thead>
                        <tr>
                            <th style="width: 50px;" class="text-center">{{$t('no')}}</th>
                            <th>{{$t('code')}}</th>
                            <th>{{$t('date')}}</th>
                            <th>{{$t('customer')}}</th>
                            <th>{{$t('sale_reputation')}}</th>
                            <th class="text-right">{{$t('grand_total')}}</th>
                            <th class="text-right">{{$t('discount')}}</th>
                            <th class="text-right">{{$t('total_amount')}}</th>
                            <th class="text-right">{{$t('total_cost')}}</th>
                            <th class="text-right">{{$t('gross_profit')}}</th>
                            <th class="text-right">{{$t('balance')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ret, index) in records" :key="index">
                            <td class="text-center">{{index+1}}</td>
                            <td>{{ret.Num}}</td>
                            <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                            <td>{{ret.CustomerName}}</td>
                            <td>{{ret.SaleRep}}</td>
                            <td class="text-right">{{$money(ret.GrandTotal)}}</td>
                            <td class="text-right">{{$money(ret.Discount)}}</td>
                            <td class="text-right">{{$money(ret.TotalAmount)}}</td>
                            <td class="text-right">{{$money(ret.TotalCost)}}</td>
                            <td class="text-right">{{$money(ret.GrossProfit)}}</td>
                            <td class="text-right">{{$money(ret.Balance)}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="5" class="text-right">{{$t('total')}}</th>
                            <th class="text-right">{{$money(summary.GrandTotal)}}</th>
                            <th class="text-right">{{$money(summary.Discount)}}</th>
                            <th class="text-right">{{$money(summary.TotalAmount)}}</th>
                            <th class="text-right">{{$money(summary.TotalCost)}}</th>
                            <th class="text-right">{{$money(summary.GrossProfit)}}</th>
                            <th class="text-right">{{$money(summary.Balance)}}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import { CustomerDropdown } from '../../Customer';
    export default {
        components: { CustomerDropdown },
        data: function(){
            return {
                query:{
                    Year: new Date().getFullYear(),
                    Month: new Date().getMonth() + 1,
                    CustomerId: '',
                    EmployeeId: ''
                },
                records:[],
                summary: {
                    GrandTotal: 0,
                    Discount: 0,
                    TotalAmount: 0,
                    TotalCost: 0,
                    GrossProfit: 0,
                    Balance: 0
                },
                employees: []
            }
        },
        created: function(){
            this.listEmployee();
            this.toList();
        },
        methods: {
            toList(){
                var loading = this.$loading.show();
                this.$api().post('report/sale/operations', this.query).then((res) => {
                    if(this.$isValid(res)){
                        this.records = res.data.Json.Sales;
                        this.calculate();
                        this.$emit('change', 2, this.query);
                    }
                }).finally(function() { loading.hide(); });
            },
            calculate(){
                let grand_total = 0;
                let discount = 0;
                let totalAmount = 0;
                let totalCost = 0;
                let gross_profit = 0;
                let balance = 0;
                this.records.map(el => {
                    grand_total += el.GrandTotal;
                    discount += el.Discount;
                    totalAmount += el.TotalAmount;
                    totalCost += el.TotalCost;
                    balance += el.Balance;
                    gross_profit += el.GrossProfit;
                });
                this.summary.GrandTotal = grand_total;
                this.summary.Discount = discount;
                this.summary.TotalAmount = totalAmount;
                this.summary.TotalCost = totalCost;
                this.summary.GrossProfit = gross_profit;
                this.summary.Balance = balance;
            },
            customerChange(e){
                if(e == null) this.query.CustomerId = '';
                else this.query.CustomerId = e.Id;
                this.toList();
            },
            listEmployee(){
				this.$api().post('employees', { Limit: 0 }).then(res => {
					this.employees = res.data.Data;
				});
			}
        }
    }
</script>